var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41670_327502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4749 5.22477C9.654 5.22477 9.83346 5.15641 9.96982 5.01969L11.9499 3.03965C12.2233 2.76654 12.2233 2.32324 11.9499 2.0498C11.6764 1.77637 11.2328 1.77637 10.96 2.0498L8.97998 4.02985C8.70654 4.30296 8.70654 4.74658 8.97998 5.01969C9.11634 5.15644 9.29577 5.22477 9.4749 5.22477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 6.2998H10.5C10.1135 6.2998 9.80005 6.61325 9.80005 6.9998C9.80005 7.38639 10.1135 7.69981 10.5 7.69981H13.3C13.6866 7.69981 14 7.38639 14 6.9998C14 6.61325 13.6866 6.2998 13.3 6.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98 9.96982L10.96 11.9499C11.0964 12.0866 11.2759 12.1549 11.455 12.1549C11.6341 12.1549 11.8132 12.0866 11.9499 11.9499C12.2233 11.6764 12.2233 11.2331 11.9499 10.96L9.96985 8.97998C9.69674 8.70654 9.25311 8.70654 8.98 8.97998C8.70654 9.25306 8.70654 9.69672 8.98 9.96982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30005 13.2998C6.30005 13.6864 6.61349 13.9998 7.00005 13.9998C7.38663 13.9998 7.70005 13.6864 7.70005 13.2998V10.4998C7.70005 10.1132 7.38663 9.7998 7.00005 9.7998C6.61349 9.7998 6.30005 10.1132 6.30005 10.4998V13.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03989 11.9499L5.01994 9.96982C5.29337 9.69672 5.29337 9.25309 5.01994 8.97998C4.74683 8.70654 4.3032 8.70654 4.03009 8.97998L2.05005 10.96C1.77661 11.2331 1.77661 11.6764 2.05005 11.9499C2.18677 12.0866 2.36587 12.1549 2.54497 12.1549C2.72407 12.1549 2.9035 12.0866 3.03989 11.9499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.9998C0 7.38639 0.313414 7.69981 0.7 7.69981H3.5C3.88656 7.69981 4.2 7.38639 4.2 6.9998C4.2 6.61325 3.88656 6.2998 3.5 6.2998H0.7C0.313414 6.2998 0 6.61325 0 6.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03989 2.0498C2.76714 1.77637 2.32349 1.77637 2.05005 2.0498C1.77661 2.32324 1.77661 2.76654 2.05005 3.03965L4.03009 5.01969C4.16646 5.15641 4.34591 5.22477 4.52501 5.22477C4.70412 5.22477 4.88357 5.15641 5.01994 5.01969C5.29337 4.74658 5.29337 4.30296 5.01994 4.02985L3.03989 2.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 4.2C7.38663 4.2 7.70005 3.88656 7.70005 3.5V0.7C7.70005 0.313414 7.38663 0 7.00005 0C6.61349 0 6.30005 0.313414 6.30005 0.7V3.5C6.30005 3.88656 6.61349 4.2 7.00005 4.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41670_327502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/InProgress.b7a53dc75bc742fc742bffe220aaef6a.svg";
export { ForwardRef as ReactComponent };